export const FULFILLMENT_METHOD_DELIVERY = 'DELIVERY';
export const FULFILLMENT_METHOD_COLLECTION = 'COLLECTION';
export const FULFILLMENT_METHOD_DEFAULT = FULFILLMENT_METHOD_DELIVERY;
export const FULFILLMENT_METHODS = [FULFILLMENT_METHOD_DELIVERY, FULFILLMENT_METHOD_COLLECTION];

export const FULFILLMENT_TYPE_DELIVERY = 'DELIVERY';
export const FULFILLMENT_TYPE_MARKETPLACE = 'RESTAURANT_FULFILLED';
export const FULFILLMENT_TYPE_COLLECTION = 'CUSTOMER_COLLECTION';

export const ORDER_TYPE_DELIVERY = 'core';
export const ORDER_TYPE_MARKETPLACE = 'marketplace';
export const ORDER_TYPE_COLLECTION = 'collection';
export const ORDER_TYPE_DEFAULT = ORDER_TYPE_DELIVERY;
export const ORDER_TYPE_TRACKING_EVENT = 'Order type';

export const FULFILLMENT_DAY_TODAY = 'TODAY';
export const FULFILLMENT_DAY_DEFAULT = FULFILLMENT_DAY_TODAY;

export const FULFILLMENT_TIME_ASAP = 'ASAP';
export const FULFILLMENT_TIME_DEFAULT = FULFILLMENT_TIME_ASAP;

export const HOMEPAGE_REFERRER = 'homepage';
export const HOME_FEED_REFERRER = 'home feed';

export const LOCAL_STORAGE_HOME_EXPLORE_COLLECTION_MODAL_KEY =
  'home_should_hide_explored_collection_modal';
export const LOCAL_STORAGE_ORDER_STATUS_KEY = 'order_status';
export const LOCAL_STORAGE_ORDER_STATUS_FAILED_ATTEMPTS_KEY = 'order_status_failed_attempts';
export const LOCAL_STORAGE_ORDER_STATUS_DISMISSED_MISSED_CALL_MODAL_KEY = (id) =>
  `dismissed_missed_call_modal_${id}`;

export const HOME_MAP_DEFAULT_RADIUS = 1500; // meters
